import { createContext, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "./useLocalStorage";
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useLocalStorage("user", null);
  const navigate = useNavigate();

  // call this function when you want to authenticate the user
  const login = async (data) => {
    setUser(data);
    navigate("/prepare");
  };

  const updateUser = async (data) => {
    setUser(data);
  }

  // call this function to sign out logged in user
  const logout = () => {
    localStorage.clear();
    setUser(null);
    navigate("/");
  };

  const value = useMemo(
    () => ({
      user,
      setUser,
      login,
      logout,
      updateUser
    }),//eslint-disable-next-line
    [user]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};